/** Authored avatar timing, not a counter of movements performed by the user.
 * Contract: arm-21s-protocol.json (a3603563). The player owns seeking and loops.
 */
export type Fitness21sPhaseKind = 'lower-half' | 'transition-to-upper' | 'upper-half' | 'transition-to-full' | 'full';
export interface Fitness21sDemonstrationPhase {
  readonly kind: Fitness21sPhaseKind;
  readonly start: number;
  readonly end: number;
  readonly demonstrationRep: number | null;
  readonly repetitionsInBlock: 7;
}
const durationSeconds = 52.8;
const segments: readonly Readonly<{ kind: Fitness21sPhaseKind; start: number; end: number; scored: boolean }>[] = Object.freeze([
  Object.freeze({ kind: 'lower-half', start: 0, end: 16.8, scored: true }),
  Object.freeze({ kind: 'transition-to-upper', start: 16.8, end: 18, scored: false }),
  Object.freeze({ kind: 'upper-half', start: 18, end: 34.8, scored: true }),
  Object.freeze({ kind: 'transition-to-full', start: 34.8, end: 36, scored: false }),
  Object.freeze({ kind: 'full', start: 36, end: 52.8, scored: true }),
]);

/** Reads evaluated clip time, so pause, seek and speed require no second clock.
 * A differently timed clip cannot silently inherit this exact protocol.
 */
export function getFitness21sDemonstrationPhase(
  exerciseId: string, currentTime: number, clipDuration: number,
): Fitness21sDemonstrationPhase | null {
  const isExactVariant = exerciseId === 'free-biceps-rosca-21' || exerciseId === 'standing-barbell-21s-curl';
  if (!isExactVariant || !Number.isFinite(currentTime)
    || !Number.isFinite(clipDuration) || Math.abs(clipDuration - durationSeconds) > .0001
    || currentTime < 0 || currentTime > clipDuration + .0001) return null;
  const time = Math.min(currentTime, durationSeconds);
  const segment = segments.find(item => time < item.end) ?? segments[segments.length - 1];
  const demonstrationRep = segment.scored ? Math.min(7, 1 + Math.floor((time - segment.start + 1e-9) / 2.4)) : null;
  return Object.freeze({ kind: segment.kind, start: segment.start, end: segment.end, demonstrationRep, repetitionsInBlock: 7 });
}
